import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Cards from '../components/Cards/Cards';
import Typography from '@mui/material/Typography';
// import GeneralSlider from '../components/Slider/GeneralSlider';
import FullSizeBanner from '../components/Banners/FullSizeBanner';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import CompareGallery from '../components/Gallery/CompareGallery';
import { Link } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import InputAdornment from '@mui/material/InputAdornment';
import ProgressCarousel from '../components/Carousel/ProgressCarousel';
import BigCard from '../components/Cards/BigCard';
import ContentCard from '../components/Cards/ContentCard';
import { useTranslation } from '../hook/Translation';
import HeroSlider from '../components/Slider/HeroSlider';

export default function HomePage() {
    
    const { t } = useTranslation();
    /* For Later */

    const data = [
        {
            header: t('homepage.mindCard1'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f33b44cd3d74.41818955.jpg`,
            
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: t('homepage.mindCard2'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/EXOMIND_2.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: t('homepage.mindCard3'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/EXOMIND_3.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
    ]

    const galleryData = [
        {
            before: '/images/mask_2.png',
            after: '/images/mask_3.png',
        },
        {
            before: '/images/mask_3.png',
            after: '/images/mask_4.png',
        },
        {
            before: '/images/mask_4.png',
            after: '/images/mask_1.png',
        },
        {
            before: '/images/mask_3.png',
            after: '/images/mask_4.png',
        },
        {
            before: '/images/mask_4.png',
            after: '/images/mask_1.png',
        },
        {
            before: '/images/mask_2.png',
            after: '/images/mask_3.png',
        },
    ];

    const OPTIONS = { dragFree: true }
    // const SLIDE_COUNT = 5
    const SLIDES = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08deb8361a7.69282773.jpg`,
            text: t('homepage.hairRemoval'),
            buttonUrl: 'skin/targeted-laser-skin-therapies'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Emface_Men_Main.png`,
            text: t('homepage.emface'),
            buttonUrl: 'skin/emface-facial-muscle-lift-tone'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08deb846821.31248578.jpg`,
            text: t('homepage.fractionalco2'),
            buttonUrl: '/skin/fractional-co2-resurfacing'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Emfusion_Girl_Main.png`,
            text: t('homepage.emfusion_facial'),
            buttonUrl: '/skin/emfusion-trans-dermal-infusion-facial'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/02/Lutronic_Square.png`,
            text: t('homepage.vascular_treatment'),
            buttonUrl: '/skin/clarity/clarity-ii-vascular-treatments'
        },
    ];

    const slides2 = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/Mask Group 52.png`,
            text: t('homepage.emfeme'),
            buttonUrl: '/body/female-intimate-wellness-one'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08da6a44160.34366870.jpg`,
            text: t('homepage.emsculpt_neo'),
            buttonUrl: 'body/emsculpt-neo-muscle-build-and-fat-reduction'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08da6a3b782.94081254.jpg`,
            text: t('homepage.emtone'),
            buttonUrl: '/body/emtone-cellulite-smoothing'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08da6a42a46.52034750.jpg`,
            text: t('homepage.exion_rf'),
            buttonUrl: '/skin/rf-collagen-induction'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/02/BTL_Emsella_PIC_Chair-model_2113.png`,
            text: t('homepage.emsella'),
            buttonUrl: '/body/emsculpt-neo-muscle-build-and-fat-reduction-one'
        },
    ];

    const heroSlider = [
        {
            title: t('homepage.mainTitle'),
            bookUrl: "Pershendetje, dua të rezervoj seancën e Exomind",
            learnUrl: "/mind/exomind",
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69fddb0b0ca301.87545106.png`,
            description: t('homepage.mainDesc')
        },
        {
            title: "EMSCULPT NEO",
            bookUrl: "Pershendetje, dua të rezervoj EMSCULPT NEO",
            learnUrl: "/body/emsculpt-neo-muscle-build-and-fat-reduction",
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69f88bd40dc389.84043782.jpg`,
            description: t('homepage.mainSlider2')
        },
        {
            title: "EMSELLA",
            bookUrl: "Pershendetje, dua të rezervoj EMSELLA",
            learnUrl: "/body/emsculpt-neo-muscle-build-and-fat-reduction-one",
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/Emsella.png`,
            description: t('homepage.mainSlider3')
        },
        {
            title: "EMFACE",
            bookUrl: "Pershendetje, dua të rezervoj EMFACE",
            learnUrl: "/skin/emface-facial-muscle-lift-tone",
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69faf9759f35f8.64540600.png`,
            description: t('homepage.mainSlider4')
        },
        {
            title: "Biologique Recherche",
            bookUrl: "Pershendetje, dua të rezervoj BIOLOGIQUE",
            learnUrl: "",
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/Biologique.png`,
            description: t('homepage.mainSlider5')
        },
    ];

    return (
        <Box>
            <FullSizeBanner>
                <HeroSlider data={heroSlider} />
            </FullSizeBanner>

            <Grid container spacing={{ md: 0, xs: 2 }} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{ md: '96px', xs: '50px' }}>
                <Grid size={{ md: 4, xs: 12 }}>
                    <Typography variant="h2" fontSize={{ md: '66px', xs: '2rem' }} color='text.secondary' fontWeight={'bold'} fontFamily={'DanmarkURW'}>Skin.</Typography>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Typography variant="body1" fontSize={{ md: '24px', xs: '1.125rem' }} color='text.secondary' fontWeight={'600'}>{t('homepage.skinDesc')}</Typography>
                </Grid>
            </Grid>

            <Grid container position={'relative'} marginTop={{ md: '102px', xs: '50px' }} sx={{ marginLeft: 'auto', width: {lg: '80%', xs: '100%'} }}>
                <Grid size={12}>
                    <ProgressCarousel slides={SLIDES} options={OPTIONS} buttonSize={{ lg: 6, md: 6, sm: 8, xs: 12 }} />
                </Grid>
            </Grid>

            <Box marginTop={{ md: '120px', xs: '50px' }}>
                <HalfSizeBanner height={{ md: '520px', xs: 'auto' }}>
                    <Box>
                        <HalfSizeBanner height={{ md: '520px', xs: 'auto' }}>
                            <BigCard
                                data={{
                                    book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Biologique Recherche Face Treatment")}`,
                                    bookName: "REZERVO KONSULTëN",
                                    // type: 'Program',
                                    // learn: '/',
                                    title: 'Biologique Recherche Face Treatment',
                                    imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/Mask Group 58.png`,
                                    flexDirection: { md: 'row-reverse', xs: 'column-reverse' },
                                    description: `${t('price_session')} 145€\n\n${t('homepage.Biologique')}`
                                }}
                            />
                        </HalfSizeBanner>
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Grid container spacing={{ md: 0, xs: 2 }} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{ md: '120px', xs: '50px' }}>
                <Grid size={{ md: 4, xs: 12 }}>
                    <Typography variant="h2" fontSize={{ md: '66px', xs: '2rem' }} color='text.secondary' fontWeight={'bold'} fontFamily={'DanmarkURW'}>Body.</Typography>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Typography variant="body1" fontSize={{ md: '24px', xs: '1.125rem' }} color='text.secondary' fontWeight={'bold'}>{t('homepage.bodyDesc')}</Typography>
                </Grid>
            </Grid>

            <Grid container position={'relative'} marginTop={{ md: '102px', xs: '50px' }} sx={{ marginLeft: 'auto', width: {lg: '80%', xs: '100%'} }}>
                <Grid size={12}>
                    <ProgressCarousel slides={slides2} options={OPTIONS} buttonSize={{ lg: 6, md: 6, sm: 8, xs: 12 }} />
                </Grid>
            </Grid>

            <Box marginTop={{ md: '127px', xs: '50px' }}>
                <HalfSizeBanner height={{ md: '520px', xs: 'auto' }} >
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Hello I'm Interested In Exomind")}`,
                            // type: 'Program',
                            btnContainer: {md: 9, xs: 12},
                            learn: '/mind/exomind',
                            title: t('homepage.exomindTitle'),
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/Mask Group 7.png`,
                            extraImageStyle: {background: '#1e353d'},
                            // flexDirection: {md: 'row-reverse', xs: 'row'},
                            description: t('homepage.exomindDesc')
                        }}
                    />
                </HalfSizeBanner>
            </Box>

            <Grid container spacing={{ md: 0, xs: 2 }} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{ md: '110px', xs: '50px' }}>
                <Grid size={{ md: 4, xs: 12 }}>
                    <Typography variant="h2" fontSize={{ md: '66px', xs: '2rem' }} color='text.secondary' fontWeight={'bold'} fontFamily={'DanmarkURW'}>Mind.</Typography>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Typography variant="body1" fontSize={{ md: '24px', xs: '1.125rem' }} color='text.secondary' fontWeight={'bold'}>{t('homepage.mindDesc')}</Typography>
                </Grid>
            </Grid>

            <Grid container sx={{ width: { md: '60%', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '102px', xs: '50px' }}>
                <Grid size={12}>
                    <Cards data={data} headerAlign={'center'} imageHeight={'300px'} />
                </Grid>
            </Grid>

            <Box width={{ md: '65%', xs: '90%' }} marginX={'auto'} marginTop={{ md: '174px', xs: '50px' }}>
                <HalfSizeBanner height={{ md: '460px', xs: 'auto' }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Deep tightening, smoothing and renewal.")}`,
                            // type: '',
                            learn: '/skin/needle-free-rf-face-tightening',
                            title: t('homepage.card2Title'),
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/EXION_Body.png`,
                            size: { md: 7.5, xs: 12 },
                            imageSize: {md: 4.5, xs: 12},
                            btnContainer: { md: 11, xs: 12 },
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('homepage.card2Desc')
                        }}
                        extraStyle={{ background: "linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%), url('/images/Mask_Group_3.png') center / cover no-repeat" }}
                    />
                </HalfSizeBanner>
            </Box>

            <Box marginTop={{ md: '120px', xs: '50px' }} bgcolor={'#f0f0ef'}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', overflow: 'hidden' }} >
                    <Typography variant="h1" color="#dfe1e1" sx={{ fontFamily: 'DanmarkURW', fontSize: { md: 'calc(11vw + 100%)', xs: 'calc(10vw + 30%)' }, width: '100%', textAlign: 'center', fontWeight: 'bold' }}>Skin.Body.Mind.</Typography>
                </Box>
                <Box sx={{ width: { md: '60%', xs: '90%' }, marginX: 'auto' }} paddingBottom={{ md: '120px', xs: '50px' }}>
                    <HalfSizeBanner height='100%'>
                        <Grid container height={'100%'}>
                            <Grid size={12}>
                                <Box height={'100%'} width={{ md: '80%', xs: '100%' }} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    <Grid container spacing={4}>
                                        <Grid size={12}>
                                            <Grid container spacing={2}>
                                                <Grid size={12}>
                                                    <Typography variant="body1" component={'p'} color='text.secondary' fontSize={{ md: '18px', xs: '16px' }} fontWeight={'bold'}>{t('homepage.exclusive_access')}</Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Typography variant="h4" color='text.secondary' fontSize={{ md: '66px', xs: '2rem' }} fontFamily={'DanmarkURW'} fontWeight={'bold'}>{t('homepage.rinu+')}</Typography>
                                                </Grid>
                                                <Grid size={{ md: 7, xs: 12 }}>
                                                    <Typography variant="body1" component={'p'} fontSize={{ md: '24px', xs: '16px' }} color='text.secondary' fontWeight={'bold'}>
                                                        {t('homepage.rinu+Desc')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={12} width={'80%'}>
                                            <Grid container spacing={4}>
                                                <Grid size={{ md: 5, xs: 12 }}>
                                                    <Button fullWidth variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10' sx={{ backgroundColor: 'text.secondary', color: 'text.primary', borderColor: 'text.secondary', textTransform: 'none', fontSize: '18px', maxHeight: '50px', width: '260px' }}>
                                                        Sign Up
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    </HalfSizeBanner>
                </Box>

            </Box>

            {/*<Box bgcolor={'#E9DFD5'} paddingTop={{ md: '102px', xs: '50px' }} paddingBottom={{ md: '158px', xs: '50px' }}>
                <Grid container width={{ md: '50%', xs: '90%' }} marginX={'auto'}>
                    <Grid size={12}>
                        <Typography textAlign={'center'} variant="body1" color='text.secondary' fontWeight={'bold'} fontSize={{ md: '18px', xs: '16px' }}>{t('homepage.resultGallery')}</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Box width={{ md: '80%', xs: '100%' }} marginX={'auto'} mt={{md: '28px'}}>
                            <Typography textAlign={'center'} variant="h6" color='text.secondary' fontSize={{ md: '24px', xs: '18px' }} fontWeight={'bold'}>{t('homepage.resultGalleryDesc')}</Typography>
                        </Box>
                    </Grid>
                    <Grid size={12}>
                        <Box  mt={{md: '60px'}}>
                            // <CompareSlider imageSet={galleryData} height={'480px'} /> 
                            <CompareGallery imageSet={galleryData} height={{ md: '480px', xs: '300px' }} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            */}

            <Box  paddingTop={{ md: '120px', xs: '50px' }} paddingBottom={{ md: '105px', xs: '50px' }}>
                <Box className="generalContainer" marginX={'auto'} gap={{ md: '89px', xs: '' }} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69f85920c74cc7.43375852.jpg`,
                            type: 'Massage Therapy',
                            title: t('homepage.card3Title'),
                            description: t('homepage.card3Desc'),
                            direction: { md: 'row-reverse', xs: 'column-reverse' },
                            learn: "/the-rinu-ritual",
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Hello I'm Interested In The RINU Ritual")}`
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
                <Box width={{ md: '60%', xs: '90%' }} marginX={'auto'}>
                    <Grid container bgcolor={'#FFFFFF'} padding={{ md: 8, xs: 6 }} marginTop={{ md: '227px', xs: '50px' }} position={'relative'} border={'solid 1px #DBDAD9'}>
                        <Box component={'img'} src='/images/Layer 2.svg' position={'absolute'} top={-32} right={20} height={80} width={107} />
                        <Grid size={12}>
                            <Grid container spacing={4}>
                                <Grid size={{ md: 11, xs: 12 }}>
                                    <Typography variant="h3" color="text.secondary" fontSize={{ md: '30px', xs: '1.125rem' }} fontWeight={'600'}>{t('homepage.expertDesc')}</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Typography variant="body1" color="text.secondary" fontSize={'16px'} fontWeight={'600'}>Dr. Yael Halaas, MD.</Typography>
                                    <Typography variant="body1" color="text.secondary">New York, NY</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
             

                <Grid container width={{ md: '60%', xs: '90%' }}  marginX={'auto'} marginTop={{ md: '150px', xs: '50px' }} spacing={{ md: 2, xs: 4 }}>
                    <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                        <Grid container gap={{md: '50px', xs: '25px'}}>
                            <Grid size={12}>
                                <Box marginX={'auto'} height={'90px'} className="flexCenter">
                                    <Box component={'img'} src='/images/Group_263.svg' sx={{ height: '100%', objectFit: 'cover' }} />
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <Typography gutterBottom variant="h3" color="text.secondary" textAlign={'center'} fontSize={'24px'} fontWeight={'bold'} mb={0}>{t('homepage.body_careTitle')}</Typography>
                                <Typography variant="body1" color="text.secondary" textAlign={'center'} >
                                    {t('homepage.body_careDesc')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                        <Grid container gap={{md: '50px', xs: '25px'}}>
                            <Grid size={12}>
                                <Box marginX={'auto'} height={'90px'} className="flexCenter">
                                    <Box component={'img'} src='/images/Group_262.svg' sx={{ height: '100%', objectFit: 'cover' }} />
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <Typography gutterBottom variant="h3" color="text.secondary" textAlign={'center'} fontSize={'24px'} fontWeight={'bold'} mb={0}>{t('homepage.skin_careTitle')}</Typography>
                                <Typography variant="body1" color="text.secondary" textAlign={'center'} >
                                    {t('homepage.skin_careDesc')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                        <Grid container gap={{md: '50px', xs: '25px'}}>
                            <Grid size={12}>
                                <Box marginX={'auto'} height={'90px'} className="flexCenter">
                                    <Box component={'img'} src='/images/Path_192.svg' sx={{ height: '100%', objectFit: 'cover' }} />
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <Typography gutterBottom variant="h3" color="text.secondary" textAlign={'center'} fontSize={'24px'} fontWeight={'bold'} mb={0}>{t('homepage.mindTitle')}</Typography>
                                <Typography variant="body1" color="text.secondary" textAlign={'center'} >
                                    {t('homepage.mindDesc2')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                        <Grid container gap={{md: '50px', xs: '25px'}}>
                            <Grid size={12}>
                                <Box marginX={'auto'} height={'90px'} className="flexCenter">
                                    <Box component={'img'} src='/images/Group_264.svg' sx={{ height: '100%', objectFit: 'cover' }} />
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <Typography gutterBottom variant="h3" color="text.secondary" textAlign={'center'} fontSize={'24px'} fontWeight={'bold'} mb={0}>{t('homepage.wellnessTitle')}</Typography>
                                <Typography variant="body1" color="text.secondary" textAlign={'center'} >
                                    {t('homepage.wellnessDesc')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <Box bgcolor={'text.secondary'} paddingTop={{ md: '250px', xs: '50px' }} paddingBottom={{ md: '250px', xs: '50px' }}>
                <Grid container>
                    <Grid size={{ md: 6, xs: 11 }} marginX={'auto'} bgcolor={'#FFF'}>
                        <Grid container padding={{ md: '100px', xs: '20px' }} justifyContent={'center'}>
                            <Grid size={12}>
                                <Typography variant="h5" color="text.secondary" fontSize={{ md: '26px', xs: '1rem' }} fontWeight={'bold'} textAlign={'center'}>{t('homepage.join_us')}</Typography>
                            </Grid>
                            <Grid size={{ md: 10, xs: 12 }} marginTop={{md: '35px', xs: '20px'}}>
                                <OutlinedInput sx={{ borderRadius: '40px', color: '#000', '.MuiOutlinedInput-notchedOutline': { borderColor: '#1E353D !important', borderStyle: 'solid !important', borderWidth: '1px !important' } }} endAdornment={<InputAdornment position="end"><ArrowForwardIosIcon /></InputAdornment>} fullWidth placeholder='Email Address' />
                            </Grid>
                            <Grid size={{ md: 10, xs: 12 }} marginTop={{md: '31px', xs: '20px'}}>
                                <Box className="alignItemsCenter">
                                    <Checkbox color='text.secondary' sx={{ paddingLeft: 0 }} />
                                    <Typography variant="body1" color="text.secondary" sx={{ a: { color: '#1E353D' } }}>{t('terms1')} <Box component={Link} sx={{ color: 'blue!important' }} to="./policy">{t('terms2')}</Box> {t('terms3')}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
};